import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const getAllParents = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/parent/getAllParents`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const searchParents = async (params, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/parent/search`,
    { params, headers: setHeaders(context) },
  );
  return response.data;
};

export const createParent = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/parent/register`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getParent = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/parent/getParent/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateParent = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/parent/updateParent/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteParent = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/parent/deleteParent/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const modifyParentPassword = async (payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/parent/modifyPassword`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getParentById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/parent/getParent/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllAcademicYearByParent = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/parent/getAllAcademicYearByParent/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// --------------------------Import/Export-------------------------------------------------------

export const importParentProfil = async (payload) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/importParent`,
    payload,
    {
      headers: { ...setHeaders(), "Content-Type": "multipart/form-data" },
    },
  );
  return response.data;
};

export const exportParentProfil = async () => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/exporte/parent/excel`,
    { headers: setHeaders(), responseType: "blob" },
  );
  return response.data;
};

export const templateParent = async () => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/download/templateParent`,

    {
      headers: setHeaders(),

      responseType: "blob",
    },
  );
  return response.data;
};